import { META_PIXEL_ALLOWED_HOSTS } from '~/utils/meta/identifiers';

export const buildPixelInitScript = (pixelId: string): string => {
  const allowed = JSON.stringify(META_PIXEL_ALLOWED_HOSTS);
  const safePixelId = JSON.stringify(pixelId);

  return `(function(){
  if (!${allowed}.includes(window.location.hostname)) return;
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', ${safePixelId});
})();`;
};
